import{createTheme}from'@mui/material/styles';

export const rasanaTokens={
 primary:'#0F5F63',
 primaryHover:'#0C5053',
 navy:'#1D384A',
 gold:'#C8A96B',
 sand:'#F4F1EA',
 ivory:'#FCFBF7',
 stone:'#D8D0C4',
 textSecondary:'#52636F',
 paper:'#FFFFFF',
 success:'#28784B',
 warning:'#946200',
 error:'#B42318',
 info:'#25637A',
 navActive:'rgba(15,95,99,.32)',
 navHover:'rgba(255,255,255,.06)',
 borderSoft:'rgba(216,208,196,.72)',
 shadow:'0 10px 30px rgba(29,56,74,.07)',
 shadowSoft:'0 2px 10px rgba(29,56,74,.05)'
}as const;

export const theme=createTheme({
 palette:{
  mode:'light',
  primary:{
   main:rasanaTokens.primary,
   dark:rasanaTokens.primaryHover,
   contrastText:'#FFFFFF'
  },
  secondary:{
   main:rasanaTokens.navy,
   contrastText:'#FFFFFF'
  },
  background:{
   default:rasanaTokens.ivory,
   paper:rasanaTokens.paper
  },
  text:{
   primary:rasanaTokens.navy,
   secondary:rasanaTokens.textSecondary
  },
  divider:rasanaTokens.stone,
  success:{main:rasanaTokens.success},
  warning:{main:rasanaTokens.warning},
  error:{main:rasanaTokens.error},
  info:{main:rasanaTokens.info}
 },
 shape:{borderRadius:8},
 spacing:8,
 typography:{
  fontFamily:'Inter, "Segoe UI", Arial, sans-serif',
  fontSize:14,
  h1:{fontSize:32,fontWeight:600,lineHeight:1.2,letterSpacing:'-.02em'},
  h2:{fontSize:28,fontWeight:600,lineHeight:1.25,letterSpacing:'-.015em'},
  h3:{fontSize:26,fontWeight:600,lineHeight:1.25,letterSpacing:'-.01em'},
  h4:{fontSize:24,fontWeight:600,lineHeight:1.3,letterSpacing:'-.01em'},
  h5:{fontSize:20,fontWeight:600,lineHeight:1.35},
  h6:{fontSize:18,fontWeight:600,lineHeight:1.4},
  subtitle1:{fontSize:16,fontWeight:600},
  subtitle2:{fontSize:14,fontWeight:600},
  body1:{fontSize:14,lineHeight:1.55},
  body2:{fontSize:13.5,lineHeight:1.5},
  caption:{fontSize:12,lineHeight:1.45},
  overline:{fontSize:11,fontWeight:600,letterSpacing:'.14em',lineHeight:1.5},
  button:{textTransform:'none',fontWeight:600,letterSpacing:0}
 },
 components:{
  MuiCssBaseline:{
   styleOverrides:{
    ':root':{
     colorScheme:'light'
    },
    body:{
     backgroundColor:rasanaTokens.ivory,
     color:rasanaTokens.navy,
     WebkitFontSmoothing:'antialiased',
     MozOsxFontSmoothing:'grayscale'
    },
    '::selection':{
     backgroundColor:'rgba(15,95,99,.18)'
    }
   }
  },
  MuiPaper:{
   styleOverrides:{
    root:{
     backgroundImage:'none'
    },
    outlined:{
     borderColor:rasanaTokens.stone
    }
   }
  },
  MuiCard:{
   styleOverrides:{
    root:{
     border:`1px solid ${rasanaTokens.borderSoft}`,
     boxShadow:rasanaTokens.shadowSoft,
     backgroundImage:'none'
    }
   }
  },
  MuiCardContent:{
   styleOverrides:{
    root:{
     padding:24,
     '&:last-child':{paddingBottom:24}
    }
   }
  },
  MuiButton:{
   defaultProps:{
    disableElevation:true
   },
   styleOverrides:{
    root:{
     borderRadius:6,
     minHeight:40,
     paddingInline:16
    },
    containedPrimary:{
     '&:hover':{
      backgroundColor:rasanaTokens.primaryHover
     }
    },
    outlined:{
     borderColor:rasanaTokens.stone,
     '&:hover':{
      borderColor:rasanaTokens.primary,
      backgroundColor:'rgba(15,95,99,.035)'
     }
    }
   }
  },
  MuiIconButton:{
   styleOverrides:{
    root:{
     borderRadius:6
    }
   }
  },
  MuiTextField:{
   defaultProps:{size:'small'}
  },
  MuiDialogActions:{
   styleOverrides:{
    root:{
     flexWrap:'wrap',
     gap:8,
     padding:16,
     borderTop:`1px solid ${rasanaTokens.borderSoft}`,
     backgroundColor:rasanaTokens.paper,
     position:'sticky',
     bottom:0,
     zIndex:2,
     '& .MuiButton-root':{minHeight:44,fontWeight:650},
     '@media (max-width:599.95px)':{
      padding:12,
      '& .MuiButton-root':{flexGrow:1}
     }
    }
   }
  },
  MuiFormHelperText:{
   styleOverrides:{root:{fontSize:12,marginTop:5,lineHeight:1.45}}
  },
  MuiOutlinedInput:{
   styleOverrides:{
    root:{
     minHeight:40,
     borderRadius:6,
     backgroundColor:rasanaTokens.paper,
     '&:hover .MuiOutlinedInput-notchedOutline':{
      borderColor:'#AFA79B'
     },
     '&.Mui-focused .MuiOutlinedInput-notchedOutline':{
      borderWidth:1.5
     }
    },
    notchedOutline:{
     borderColor:rasanaTokens.stone
    }
   }
  },
  MuiInputLabel:{
   styleOverrides:{
    root:{
     fontSize:14,
     '& .MuiFormLabel-asterisk':{color:'#B53B38',fontWeight:700},
     '&.Mui-error':{color:'#A62727'}
    }
   }
  },
  MuiChip:{
   styleOverrides:{
    root:{
     minHeight:26,
     borderRadius:16,
     fontWeight:600
    }
   }
  },
  MuiAlert:{
   styleOverrides:{
    root:{
     borderRadius:8,
     border:'1px solid currentColor'
    }
   }
  },
  MuiDivider:{
   styleOverrides:{
    root:{
     borderColor:rasanaTokens.borderSoft
    }
   }
  },
  MuiTable:{
   styleOverrides:{
    root:{
     backgroundColor:rasanaTokens.paper
    }
   }
  },
  MuiTableHead:{
   styleOverrides:{
    root:{
     backgroundColor:rasanaTokens.sand
    }
   }
  },
  MuiTableCell:{
   styleOverrides:{
    head:{
     color:rasanaTokens.navy,
     fontSize:12.5,
     fontWeight:600,
     letterSpacing:'.02em'
    },
    root:{
     borderBottom:`1px solid ${rasanaTokens.borderSoft}`
    }
   }
  },
  MuiTabs:{
   styleOverrides:{
    root:{
     minHeight:42,
     borderBottom:`1px solid ${rasanaTokens.borderSoft}`
    },
    indicator:{
     height:2
    }
   }
  },
  MuiTab:{
   styleOverrides:{
    root:{
     minHeight:42,
     textTransform:'none',
     fontWeight:600,
     color:rasanaTokens.textSecondary,
     '&.Mui-selected':{
      color:rasanaTokens.primary
     }
    }
   }
  },
  MuiDialog:{
   styleOverrides:{
    paper:{
     borderRadius:10,
     border:`1px solid ${rasanaTokens.borderSoft}`,
     boxShadow:rasanaTokens.shadow
    }
   }
  },
  MuiDrawer:{
   styleOverrides:{
    paper:{
     backgroundImage:'none'
    }
   }
  },
  MuiTooltip:{
   styleOverrides:{
    tooltip:{
     backgroundColor:rasanaTokens.navy,
     fontSize:12,
     borderRadius:6
    }
   }
  }
 }
});
